import ColumnsContent from '../../../../../../components/Hocs/ColumnsContent';
import ContentSearch from './ContentSearch';
import RightSidebar from '../RightSidebar/RightSidebar';

export default ColumnsContent(ContentSearch, RightSidebar);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentSearch/index.js